<section class="events" id="events">
  <div class="events__grid"></div>
  <div class="blob blob-1"></div>
  <div class="blob blob-2"></div>

  <div class="container">
    <div class="events__header">
      <span class="section-tag">{{ t().ev_tag }}</span>
      <h2 class="section-title">{{ t().ev_title }}<br><span>{{ t().ev_subtitle }}</span></h2>
    </div>

    <div class="events__grid">
      <div class="ev-card" *ngFor="let e of events(); let i = index" [style.--card-delay]="i * 0.1 + 's'">
        <div class="ev-card__num">0{{ i + 1 }}</div>
        <h3>{{ e.title }}</h3>
        <p>{{ e.desc }}</p>
      </div>
    </div>
  </div>
</section>